export default `
# Session

\`Session\` is the object returned by the Auth service when an API client opens or refreshes a session with \`X-Auth-Mode: token\`.

For successful API authentication, it contains both tokens the client must manage:

- \`jwtToken\`: short-lived access token used as a Bearer token in protected API calls.
- \`refreshToken\`: token used to obtain a new \`Session\` when the JWT expires.

## JSON shape

\`\`\`json
{
  "jwtToken": "<jwt access token>",
  "refreshToken": "<refresh token>",
  "mfaProvider": null
}
\`\`\`

## Fields

| Field          | Type   | Nullable | Description |
|----------------|--------|----------|-------------|
| \`jwtToken\`     | string | yes      | JWT access token. Send it as \`Authorization: Bearer <jwtToken>\` in protected API calls. |
| \`refreshToken\` | string | yes      | Refresh token. Send it to \`PUT /api/auth/session\` to obtain a new \`Session\`. |
| \`mfaProvider\`  | string | yes      | MFA provider marker returned by the Auth service when additional verification is required. It is \`null\` when the session is successfully open. |

## Token rotation

Every successful refresh returns a new \`Session\` object. Replace both stored tokens with the new \`jwtToken\` and \`refreshToken\`; the previous refresh token should no longer be used.
`



// WEBPACK FOOTER //
// ./src/components/docs/api/content/session.js